import { pdfjs } from 'react-pdf';

// Pin pdfjs worker version to match the bundled pdfjs-dist.
// Using `?url` Vite import to bundle the worker as a static asset.
import workerUrl from 'pdfjs-dist/build/pdf.worker.min.mjs?url';

pdfjs.GlobalWorkerOptions.workerSrc = workerUrl;

export {};
